// PatientProfileImage.js

import React from "react";
import { Image } from "react-native";

import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome";
import { faPaw } from "@fortawesome/free-solid-svg-icons";

// Allowed Styles: borderWidth, color, width, padding. (Note: Padding only works on the default SVG paw icon. No effect on Image tag.)

const PatientProfileImage = ({profile_image_id=0, style={}, ...props})=>{
  if (!Number(profile_image_id)) {
    const default_style = {
      backgroundColor: "#ffffff",
      borderWidth: (style.borderWidth||2),
      borderStyle: "solid",
      borderColor: (style.color||"#dddddd"),
      borderRadius: "50%",
      color: (style.color||"#dddddd"),
      height: ((style.width-(style.borderWidth||2)-(style.padding||3)) || (46-(style.borderWidth||2)-(style.padding||3))),
      width: ((style.width-(style.borderWidth||2)-(style.padding||3)) || (46-(style.borderWidth||2)-(style.padding||3))),  // For unknown reason,  FontAwesome resulting width is 5px wider than expected, so minus 5 from the math here ⬅.
      padding: (style.padding||3),
      marginRight: (("marginRight" in style)?style.marginRight:12),
    };
    return (
      <FontAwesomeIcon icon={faPaw} style={default_style} {...props} />
    );
  }
  const default_style = {
    backgroundColor: "#ffffff",
    borderRadius: "50%",
    height: (style.width||46),
    width: (style.width||46),
    marginRight: (("marginRight" in style)?style.marginRight:12),
  };
  return (
    <Image source={{ uri: window.main.api.url + window.main.api.getPatientImage.replace("{profile_image_id}", profile_image_id)}} style={default_style} {...props} accessibilityLabel="Pet Image" />
  );
}

export default PatientProfileImage;
